import {
  BILLING_PAYMENTS_ROUTE,
  CONTACT_AGENT_ROUTE,
  DOCUMENTS_INFO_ROUTE,
  LOGIN_ROUTE,
  MAKE_CLAIM_ROUTE,
  POLICY_ACTION_ROUTE,
  POLICY_LISTING_ROUTE,
  DELETE_ACCOUNT_ROUTE,
  RESET_PASSWORD_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  REGISTER_ROUTE,
  SHAREABLE_ROUTE,
  ACCOUNT_DELETION,
} from "../../src/navigation/NavigationConstants"; // Import the LOGIN_ROUTE constant

export const Linking = {
  prefixes: ["http://localhost:3000", "policyholder://"],
  config: {
    initialRouteName: LOGIN_ROUTE,

    screens: {
      [LOGIN_ROUTE]: {
        path: "login",
      },

      [REGISTER_ROUTE]: {
        path: "register",
      },
      [POLICY_LISTING_ROUTE]: {
        path: "policies",
      },
      [POLICY_ACTION_ROUTE]: {
        path: "policyAction",
      },
      [CONTACT_AGENT_ROUTE]: {
        path: "contactAgent",
      },
      [MAKE_CLAIM_ROUTE]: {
        path: "reportClaim",
      },
      [BILLING_PAYMENTS_ROUTE]: {
        path: "billingPayments",
      },
      [DOCUMENTS_INFO_ROUTE]: {
        path: "documentsInfo",
      },

      [DELETE_ACCOUNT_ROUTE]: {
        path: "deleteAccount",
      },
      [RESET_PASSWORD_ROUTE]: {
        path: "resetPassword",
      },
      [FORGOT_PASSWORD_ROUTE]: {
        path: "forgotPassword",
      },
      [SHAREABLE_ROUTE]: {
        path: "shareable",
      },
      [ACCOUNT_DELETION]: {
        path: "accountDeletion",
      },
      // PdfViewer: {
      //   path: 'pdfViewer',
      // },
      // PolicyActionsBlockView: {
      //   path: 'policyActionsBlockView',
      // },
      // PolicyActionsListView: {
      //   path: 'policyActionsListView',
      // },
    },
  },
};
